// Code de retour d'un joueur : 8 caractères tirés de son jeton secret (SHA-256), pour retrouver son héros sur un
// autre appareil, ou depuis l'icône de l'écran d'accueil (sur iPhone, elle ne partage pas la mémoire de Safari).
// Même calcul côté serveur (WorldDO.resume) et côté client (onglet Compagnons) : rien de plus à stocker.

/** Mêmes 32 caractères que les codes de monde (ni 0/O ni 1/I) ; 256 octets / 32 lettres : tirage sans biais. */
const ALPHABET = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
export const RETOUR_LENGTH = 8;

/** Code de retour d'un jeton, présenté « ABCD-EFGH ». */
export async function codeDeRetour(token: string): Promise<string> {
  const digest = new Uint8Array(await crypto.subtle.digest("SHA-256", new TextEncoder().encode(`veillee:retour:${token}`)));
  let code = "";
  for (let i = 0; i < RETOUR_LENGTH; i++) code += ALPHABET[digest[i] % ALPHABET.length];
  return `${code.slice(0, 4)}-${code.slice(4)}`;
}

/** Saisie normalisée : majuscules, tiret, espaces et caractères hors alphabet retirés. */
export function normaliserRetour(raw: string): string {
  const upper = raw.toUpperCase();
  let out = "";
  for (const ch of upper) if (ALPHABET.includes(ch)) out += ch;
  return out.slice(0, RETOUR_LENGTH);
}

// Lien de connexion : le code du monde et le code de retour dans le fragment (#), que le navigateur n'envoie jamais
// au serveur. Il ouvre le héros sur n'importe quel appareil ; collé dans l'accueil, il remplit les deux codes.
const LINK_RE = /connexion=([0-9A-Z]{6})-?([0-9A-Z]{4})-?([0-9A-Z]{4})/i;
const KEY_RE = /(?:^|[^0-9A-Z])([0-9A-Z]{6})-([0-9A-Z]{4})-([0-9A-Z]{4})(?![0-9A-Z])/i;

/** Lien de connexion d'un joueur : `${origin}/#connexion=CODE12-ABCD-EFGH`. */
export function lienDeConnexion(origin: string, worldCode: string, retour: string): string {
  const r = normaliserRetour(retour);
  return `${origin}/#connexion=${worldCode}-${r.slice(0, 4)}-${r.slice(4)}`;
}

/** Code du monde et code de retour lus dans un lien de connexion, ou une clé « CODE12-ABCD-EFGH » ; null sinon. */
export function lireConnexion(raw: string): { code: string; retour: string } | null {
  const m = LINK_RE.exec(raw) ?? KEY_RE.exec(raw);
  if (!m) return null;
  const code = m[1].toUpperCase();
  const retour = `${m[2]}${m[3]}`.toUpperCase();
  for (const ch of code + retour) if (!ALPHABET.includes(ch)) return null;
  return { code, retour };
}
